import { render, staticRenderFns } from "./StudentTab.vue?vue&type=template&id=6c6b16f4&scoped=true"
import script from "./StudentTab.vue?vue&type=script&lang=ts"
export * from "./StudentTab.vue?vue&type=script&lang=ts"
import style0 from "./StudentTab.vue?vue&type=style&index=0&id=6c6b16f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6b16f4",
  null
  
)

export default component.exports